export default "__VITE_ASSET__BJR8K_Z5__"